import React from 'react'

import { MarbleRating } from './MarbleRating'

import './BigMarbleRating.less'

export const BigMarbleRating = (props: any) => (
  <MarbleRating className="MarbleRating BigMarbleRating" {...props} />
)
